/**
 * Die faces for activation cost (SPEC.md §8.3), as geometry rather than glyphs.
 *
 * The Unicode faces ⚀–⚄ were readable but took the text colour as one piece, so the frame
 * and the pips could not differ. Drawing them means the frame stays neutral and the pips
 * carry the colour — and it sidesteps font coverage, which is not guaranteed for
 * U+2680–2685 on every phone.
 *
 * Values, not components, so React Fast Refresh keeps working (D48).
 */

/** Pip positions on a 3×3 grid, in the conventional die arrangement. */
export const PIP_LAYOUTS: Record<number, [number, number][]> = {
  1: [[1, 1]],
  2: [
    [0, 0],
    [2, 2],
  ],
  3: [
    [0, 0],
    [1, 1],
    [2, 2],
  ],
  4: [
    [0, 0],
    [2, 0],
    [0, 2],
    [2, 2],
  ],
  5: [
    [0, 0],
    [2, 0],
    [1, 1],
    [0, 2],
    [2, 2],
  ],
};

/**
 * The rarity ramp: grey, green, blue, magenta, orange.
 *
 * Borrowed deliberately from games, where it means "how much of a thing is this" and is
 * already legible at a glance to anyone who has played one. Here it reads as activation
 * cost — a 5 should look like it costs something before you have read the number.
 */
export const ENERGY_COLORS: Record<number, string> = {
  1: "#9aa0b5",
  2: "#6ee7a8",
  3: "#7fb2ff",
  4: "#d98bff",
  5: "#f6a04d",
};

export const DIE_FRAME = "#e7e9f2";
